const co = require('co');

const config = $stateProvider => {
  $stateProvider.state('bench.ledgers', {
    url: '/new-ledgers/{editAccount:[0-9]*}?selectedTab',
    params: {
      editAccount: {
        value: null,
        squash: true,
        dynamic: true,
      },
    },
    resolve: {
      _ledgers(_User, LedgerCollection) {
        return co(function* generator() {
          const clientId = _User.getClientId();

          const ledgers = new LedgerCollection(clientId);
          yield ledgers.$promise;

          return ledgers;
        });
      },
      _fdsConnections(_User, FdsConnectionCollection) {
        return co(function* generator() {
          const clientId = _User.getClientId();

          const financialConnections = new FdsConnectionCollection(clientId);
          yield financialConnections.$fetch();

          return financialConnections;
        });
      },
      _ledgerCategoryOrderCollection(_User, LedgerCategoryOrderCollection) {
        return co(function* generator() {
          const clientId = _User.getClientId();

          const ledgerCategoryOrderCollection = new LedgerCategoryOrderCollection(clientId);
          yield ledgerCategoryOrderCollection.$promise;

          return ledgerCategoryOrderCollection;
        });
      },
      _templateLedgerCollection(TemplateLedgerCollection) {
        return co(function* generator() {
          const templateLedgerCollection = new TemplateLedgerCollection();
          yield templateLedgerCollection.$promise;

          return templateLedgerCollection;
        });
      },
    },
    views: {
      '': {
        template: `
          <bl-ledgers
            ledger-collection-id="vm.ledgerCollectionId"
            selected-tab="vm.selectedTab"
          >
          </bl-ledgers>
        `,
        controller: function Ctrl($stateParams, _ledgers) {
          this.ledgerCollectionId = _ledgers.$storeId();

          this.selectedTab = $stateParams.selectedTab;
        },

        controllerAs: 'vm',
      },
    },
  });
};

const deps = [
  require('angular-ui-router'),
  require('data/collection/ledger').name,
  require('data/collection/fdsConnection').name,
  require('ui/web/ledgers').name,
];

module.exports = angular.module('bench.app.mainapp.ledgers', deps).config(config);
